/**
 * Created by Holger Szuesz <development@szuesz.de> on 30.05.2019 15:48
 *
 */

import * as React from 'react';

import '../styles/Projects.css';

class Projects extends React.Component<any> {
    public render() {
        return (
            <p className="App-intro">
                Projects
            </p>
        );
    }
}

export default Projects;



// WEBPACK FOOTER //
// ./src/components/Projects.tsx